export const MINIMUM_GA_ACCESS_APP_YEAR = 2024;
